export default __webpack_public_path__ + "static/media/furrow-S.7f200c81.jpg";